import { render } from "./ProducePropositionList.vue?vue&type=template&id=37683bda"
import script from "./ProducePropositionList.vue?vue&type=script&lang=js"
export * from "./ProducePropositionList.vue?vue&type=script&lang=js"

import "./ProducePropositionList.vue?vue&type=style&index=0&id=37683bda&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__